import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl, FormControl, ValidatorFn, ValidationErrors, FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { CommonModule } from '@angular/common';
import { UtilityService } from '../../services/utility/utility.service';
import { AccountCentreService } from '../account-centre.service';
import { countryResponse } from '../../models/country/countryResponse';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../services/account/auth.service';
import { Store } from '@ngxs/store';
import { UserSelectors } from '../../states/user/user-selector';
import { forkJoin, of, switchMap } from 'rxjs';
import { UserResponse } from '../../models/account/userResponse';
import { MultiSelectModule } from 'primeng/multiselect';
import { UpdateUserProfileRequest } from '../../models/account-centre/updateUserProfileRequest';
import { UserStateModel } from '../../states/user/user-state-model';
import { AuthRoles } from '../../models/enums/enums';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { InstituteService } from '../../services/institute/institute.service';
import { SearchInstituteResponse } from '../../models/institute/searchInstituteResponse';
import { EditorContent, ContentEditorComponent } from '../../utility/content-editor/content-editor.component';
import { CourseLevelEnum, CourseLevelEnumDescriptions } from '../../models/enums/courseLevelEnum';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-update-basic-info',
  standalone: true,
  imports: [
    ButtonModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    ReactiveFormsModule,
    CommonModule,
    MultiSelectModule,
    CheckboxModule,
    FormsModule,
    AutoCompleteModule,
    ContentEditorComponent,
    ToastModule
],
  providers: [MessageService],
  templateUrl: './update-basic-info.component.html',
  styleUrl: './update-basic-info.component.scss'
})
export class UpdateBasicInfoComponent implements OnInit {

  user!: UserStateModel;
  basicInfoForm!: FormGroup;
  countries: countryResponse[] = [];
  genders: { name: string; value: number }[] = [];
  collageStartOnTimings: { name: string; key: string }[] = [];
  years: { name: string; value: string }[] = [];
  months: { name: string; value: string }[] = [];
  portal:  string |  undefined;
  email: string | undefined;
  degreePrefs = [
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsDegree], key: CourseLevelEnum.BachelorsDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.BachelorsAndMastersDegree], key: CourseLevelEnum.BachelorsAndMastersDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Certificate], key: CourseLevelEnum.Certificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Diploma], key: CourseLevelEnum.Diploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.DoctoralDegree], key: CourseLevelEnum.DoctoralDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.DualDegree], key: CourseLevelEnum.DualDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.FoundationDegree], key: CourseLevelEnum.FoundationDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.MastersDegree], key: CourseLevelEnum.MastersDegree },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateCertificate], key: CourseLevelEnum.PostgraduateCertificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PostgraduateDiploma], key: CourseLevelEnum.PostgraduateDiploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.PreSessionalProgram], key: CourseLevelEnum.PreSessionalProgram },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateCertificate], key: CourseLevelEnum.UndergraduateCertificate },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.UndergraduateDiploma], key: CourseLevelEnum.UndergraduateDiploma },
    { name: CourseLevelEnumDescriptions[CourseLevelEnum.Vocational], key: CourseLevelEnum.Vocational }
  ]

  initialContent: string = '';
  textContent: string = '';
  htmlContent: string = '';
  // totalWords: number = 0;

  loading = false;
  submitted = false;
  userDetails: UserResponse|null=null;
  showOtherServiceInput: boolean = false;
  otherServiceSpecControl = new FormControl('');
  showOtherSubjectInput: boolean = false;
  otherSubjectSpecControl = new FormControl('');
  searchAutoCompleteInstitutes: SearchInstituteResponse[] = [];
  private fb = inject(FormBuilder);
  private utilityService = inject(UtilityService);
  private accountCentreService = inject(AccountCentreService);

  serviceOptions = [
    { name: 'US Undergraduate', key: 'US Undergraduate' },
    { name: 'US Graduate', key: 'US Graduate' },
    { name: 'UK Undergraduate', key: 'UK Undergraduate' },
    { name: 'UK Graduate', key: 'UK Graduate' },
    { name: 'Canadian Undergraduate', key: 'Canadian Undergraduate' },
    { name: 'Canadian Graduate', key: 'Canadian Graduate' },
    { name: 'Indian Graduate', key: 'Indian Graduate' },
    { name: 'Indian Undergraduate', key: 'Indian Undergraduate' },
    { name: 'Australia Undergraduate', key: 'Australia Undergraduate' },
    { name: 'Australia Graduate', key: 'Australia Graduate' },
    { name: 'UAE Graduate', key: 'UAE Graduate' },
    { name: 'UAE Undergraduate', key: 'UAE Undergraduate' },
    { name: 'Singapore Graduate', key: 'Singapore Graduate' },
    { name: 'Singapore Undergraduate', key: 'Singapore Undergraduate' }
  ];

  subjectOptions = [
    { name: 'Engineering & Technology', key: 'Engineering & Technology' },
    { name: 'Computer Science & IT', key: 'Computer Science & IT' },
    { name: 'Medicine & Health Sciences', key: 'Medicine & Health Sciences' },
    { name: 'Business & Management', key: 'Business & Management' },
    { name: 'Law & Legal Studies', key: 'Law & Legal Studies' },
    { name: 'Natural Sciences', key: 'Natural Sciences' },
    { name: 'Mathematics & Statistics', key: 'Mathematics & Statistics' },
    { name: 'Architecture & Urban Planning', key: 'Architecture & Urban Planning' },
    { name: 'Arts', key: 'Arts' },
    { name: 'Design & Creative Studies', key: 'Design & Creative Studies' },
    { name: 'Education', key: 'Education' },
    { name: 'Social Sciences & Humanities', key: 'Social Sciences & Humanities' },
    { name: 'Psychology & Counselling', key: 'Psychology & Counselling' },
    { name: 'Agriculture & Veterinary Sciences', key: 'Agriculture & Veterinary Sciences' },
    { name: 'Environmental & Earth Sciences', key: 'Environmental & Earth Sciences' },
    { name: 'Languages & Linguistics Communication & Media Studies', key: 'Languages & Linguistics Communication & Media Studies' },
    { name: 'Hospitality, Tourism & Sports', key: 'Hospitality, Tourism & Sports' },
    { name: 'Religion, Philosophy & Ethics', key: 'Religion, Philosophy & Ethics' },
    { name: 'Social Work & Community Services', key: 'Social Work & Community Services' },
    { name: 'Vocational', key: 'Vocational' }
  ];

  constructor(private messageService: MessageService,private authService:AuthService,private store:Store,
    private instituteService: InstituteService, private cdr: ChangeDetectorRef
  ) {
    this.buildForm();
  }

  filterInstitutes(event: AutoCompleteCompleteEvent): void {
    if (event.query.length > 3) {
      this.instituteService.searchInstitute(event.query).subscribe({
        next: (response: SearchInstituteResponse[]) => {
          this.searchAutoCompleteInstitutes = response.length > 0 ? response : [{ name: event.query }];
        }
      });
    } else {
      this.searchAutoCompleteInstitutes = [{ name: event.query }];
    }
  }

  atLeastOneServiceSpecializationValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const specialization = group.get('servicesSpecialization')?.value || [];
      const other = group.get('otherServiceSpecControl')?.value?.trim();

      if ((specialization && specialization.length > 0) || other) {
        return null;
      }

      return { servicesSpecializationRequired: true };
    };
  }

  atLeastOneSubjectSpecializationValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const specialization = group.get('subjectSpecialization')?.value || [];
      const other = group.get('otherSubjectSpecControl')?.value?.trim();

      if ((specialization && specialization.length > 0) || other) {
        return null;
      }

      return { subjectSpecializationRequired: true };
    };
  }

  createCheckboxForOtherService(){
    const userSpecs = this.userDetails?.servicesSpecialization || [];
    const tempSpecs = [...this.serviceOptions];

    userSpecs.forEach(userSpec => {
      if(!tempSpecs.find(spec => spec.key === userSpec)){
        tempSpecs.push({name: userSpec, key: userSpec})
      }
    });
    this.serviceOptions = tempSpecs;
  }

  createCheckboxForOtherSubject(){
    const userSpecs = this.userDetails?.subjectSpecialization || [];
    const tempSpecs = [...this.subjectOptions];

    userSpecs.forEach(userSpec => {
      if(!tempSpecs.find(spec => spec.key === userSpec)){
        tempSpecs.push({name: userSpec, key: userSpec})
      }
    });
    this.subjectOptions = tempSpecs;
  }

  onOtherServiceChange(event: CheckboxChangeEvent){
      if(event.checked.length !==0){
        this.showOtherServiceInput = true;
        this.otherServiceSpecControl.setValidators([Validators.required]);
      }else{
        this.showOtherServiceInput = false;
        this.otherServiceSpecControl.setValue('');
        this.otherServiceSpecControl.clearValidators();
      }
      this.otherServiceSpecControl.updateValueAndValidity();
  }

  onOtherSubjectChange(event: CheckboxChangeEvent){
      if(event.checked.length !==0){
        this.showOtherSubjectInput = true;
        this.otherSubjectSpecControl.setValidators([Validators.required]);
      }else{
        this.showOtherSubjectInput = false;
        this.otherSubjectSpecControl.setValue('');
        this.otherSubjectSpecControl.clearValidators();
      }
      this.otherSubjectSpecControl.updateValueAndValidity();
  }

  addOtherService(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    const val = this.otherServiceSpecControl.value;
    if (val && val.trim()) {
      const trimmedVal = val.trim();
      if (!this.serviceOptions.find(spec => spec.key === trimmedVal)) {
        this.serviceOptions.push({ name: trimmedVal, key: trimmedVal });
      }
      const currentSelected = this.basicInfoForm.get('servicesSpecialization')?.value || [];
      if (!currentSelected.includes(trimmedVal)) {
        this.basicInfoForm.get('servicesSpecialization')?.setValue([...currentSelected, trimmedVal]);
      }
      this.otherServiceSpecControl.setValue('');
      this.otherServiceSpecControl.clearValidators();
      this.otherServiceSpecControl.updateValueAndValidity();
    }
  }

  addOtherSubject(event?: Event) {
    if (event) {
      event.preventDefault();
    }
    const val = this.otherSubjectSpecControl.value;
    if (val && val.trim()) {
      const trimmedVal = val.trim();
      if (!this.subjectOptions.find(spec => spec.key === trimmedVal)) {
        this.subjectOptions.push({ name: trimmedVal, key: trimmedVal });
      }
      const currentSelected = this.basicInfoForm.get('subjectSpecialization')?.value || [];
      if (!currentSelected.includes(trimmedVal)) {
        this.basicInfoForm.get('subjectSpecialization')?.setValue([...currentSelected, trimmedVal]);
      }
      this.otherSubjectSpecControl.setValue('');
      this.otherSubjectSpecControl.clearValidators();
      this.otherSubjectSpecControl.updateValueAndValidity();
    }
  }

  private loadUserData(){
    this.store.select(UserSelectors.getUser).pipe(
      switchMap((user)=>{
        if(!user || !user.id){
          return of(null);
        }
        this.user = user;
        this.email = user.email;
        if(user.role.includes(AuthRoles.Student)){
          this.portal = 'student';
        }else if(user.role.includes(AuthRoles.Mentor)){
          this.portal = 'mentor';
        }
        return this.authService.getUserByid(user.id);
      })
    ).subscribe({
      next: (response) => {
        if(response != null){
          this.userDetails = response;
          this.initialContent = response.whyToBeMentor || '';
          this.textContent = response.whyToBeMentor || '';
          this.htmlContent = response.whyToBeMentor || '';
          this.createCheckboxForOtherService();
          this.createCheckboxForOtherSubject();
          this.populateForm();
        }
      }
    })
  }

  populateForm(){
    const rawHomeCountry = this.userDetails?.homeCountry;
    let homeCountryValue: any = null;

    if (rawHomeCountry) {
      if (this.portal === 'mentor') {
        homeCountryValue = typeof rawHomeCountry === 'string'
          ? rawHomeCountry.split(',').map(c => c.trim()).filter(c => c !== '')
          : rawHomeCountry;
      } else {
        /** * STUDENT LOGIC: */
        homeCountryValue = typeof rawHomeCountry === 'string'
          ? rawHomeCountry.split(',')[0].trim()
          : (Array.isArray(rawHomeCountry) ? rawHomeCountry[0] : rawHomeCountry);
      }
    }

    this.basicInfoForm.patchValue({
      firstName: this.userDetails?.firstName,
      lastName:  this.userDetails?.lastName,
      bornOn:  this.userDetails?.bornOn ? new Date(this.userDetails.bornOn) : null,
      destination:  this.userDetails?.destination,
      degreePreference:  this.userDetails?.degreePreference,
      collageStartOn:  this.userDetails?.collageStartOn,
      homeCountry:  homeCountryValue,
      gender: this.userDetails?.gender,
      organisation: this.userDetails?.organisation,
      whyToBeMentor: this.userDetails?.whyToBeMentor,
      undergraduateCollege: this.userDetails?.graduationCollageName,
      graduateCollege: this.userDetails?.mastersCollageName,
      servicesSpecialization: this.userDetails?.servicesSpecialization,
      subjectSpecialization: this.userDetails?.subjectSpecialization,
      topAdmits: this.userDetails?.topAdmits?.map((x: any) => ({ name: x.instituteName, id: x.instituteId })) || [],
      profileVideoUrl: this.userDetails?.profileVideoUrl,
      totalExperience:{
        years: this.years.find(y => y.name === this.userDetails?.totalExperience?.split('.')[0]),
        months: this.months.find(m => m.name === (this.userDetails?.totalExperience?.split('.')[1] || '00')),
      }
    })
  }

  buildForm() {
    this.basicInfoForm = this.fb.group({
      firstName: [''],
      lastName: [''],
      bornOn: [''],
      destination: [[]],
      degreePreference: [''],
      collageStartOn: [''],
      homeCountry: [''],
      gender: [''],
      organisation: [''],
      whyToBeMentor: [''],
      undergraduateCollege: [''],
      graduateCollege: [''],
      servicesSpecialization: [''],
      otherServiceSpecControl: [''],
      subjectSpecialization: [''],
      otherSubjectSpecControl: [''],
      topAdmits: [[]],
      profileVideoUrl: ['',[
        (control: AbstractControl) => {
          const value = control.value;
          if (!value) return null;

          const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|shorts\/)|youtu\.be\/)[\w-]{11}([?&]\S*)?$/;
          return youtubeRegex.test(value) ? null : { invalidYoutubeUrl: true };
        }
      ]],
      totalExperience:this.fb.group({
        years: [null],
        months: [null],
      }),

    },
    // {
    //   validators: [this.atLeastOneServiceSpecializationValidator(), this.atLeastOneSubjectSpecializationValidator()]
    // }
  );
    this.otherServiceSpecControl = this.basicInfoForm.get('otherServiceSpecControl') as FormControl;
    this.otherSubjectSpecControl = this.basicInfoForm.get('otherSubjectSpecControl') as FormControl;
  }
  ngOnInit(): void {
    this.setCollageStartOnTimings();
    this.utilityService.getCountries().subscribe({
      next: (res) => this.countries = res.result,
      error: () => this.countries = []
    });
    this.genders = [
      { name: 'Male', value: 1 },
      { name: 'Female', value: 2 },
      { name: 'Other', value: 3 }
    ]
    this.loadUserData();
    this.setYearsOptions();
    this.setMonthsOptions();
  }

  private setMonthsOptions(){
    this.months = Array.from({ length: 13}, (_, i) => ({
      name: i.toString().padStart(2, '0'),
      value:  i.toString()
    }))
  }
  private setYearsOptions(){
    this.years = Array.from({  length: 40}, (_, i) => ({
      name: i.toString(),
      value: i.toString()
    }))
  }

  private calculateTotalExperience(experience: any): string | null{
    if(!experience || (!experience.years && !experience.months)){
      return null;
    }
    const  years = Number(experience.years?.name) ||  0;
    const  months = Number(experience.months?.name) ||  0;
    return (years + (months / 12)).toFixed(2);
  }

  setCollageStartOnTimings() {
    const currentYear = new Date().getFullYear(); // Get the current year
    const terms = ['Spring', 'Fall']; // Terms to add

    for (let yearOffset = 0; yearOffset <= 3; yearOffset++) {
      for (const term of terms) {
        const year = currentYear + yearOffset; // Calculate the year
        const key = `${term} ${year}`;
        const name = `${term} ${year}`; // Create the term name
        this.collageStartOnTimings.push({ name, key });
      }
    }
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.basicInfoForm.invalid) return;
    this.loading = true;
    const formData = this.basicInfoForm.value;
    let finalServiceSpec: string[] = formData.servicesSpecialization || [];
    if(this.showOtherServiceInput && this.otherServiceSpecControl.value){
      finalServiceSpec.push(this.otherServiceSpecControl.value)
    }
    
    let finalSubjectSpec: string[] = formData.subjectSpecialization || [];
    if(this.showOtherSubjectInput && this.otherSubjectSpecControl.value){
      finalSubjectSpec.push(this.otherSubjectSpecControl.value)
    }

    let topAdmitsIds: string[] = [];
    if(formData.topAdmits && Array.isArray(formData.topAdmits)){
      topAdmitsIds = formData.topAdmits.map((x: any) => x.id).filter((id: any) => id);
    }

    /**
     * HOME COUNTRY CONVERSION:
     * If Mentor selected multiple (Array).
     * If Student selected single (String).
     */
    let homeCountryPayload = formData.homeCountry;
    if (Array.isArray(homeCountryPayload)) {
      homeCountryPayload = homeCountryPayload.join(',');
    }

    const request: UpdateUserProfileRequest = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      bornOn: formData.bornOn,
      destination: formData.destination,
      degreePreference: formData.degreePreference,
      collageStartOn: formData.collageStartOn,
      homeCountry: homeCountryPayload,
      gender: formData.gender,
      totalExperience: this.calculateTotalExperience(formData.totalExperience),
      organisation: formData.organisation,
      whyToBeMentor: this.htmlContent,
      graduationCollageName: formData.undergraduateCollege,
      mastersCollageName: formData.graduateCollege,
      servicesSpecialization: finalServiceSpec,
      subjectSpecialization: finalSubjectSpec,
      topAdmits: topAdmitsIds,
      profileVideoUrl: formData.profileVideoUrl
    };

    if (this.portal === 'student') {
      const born: Date | null = formData.bornOn;
      const dateOfBirth =
        born instanceof Date
          ? `${born.getFullYear()}-${String(born.getMonth() + 1).padStart(2, '0')}-${String(born.getDate()).padStart(2, '0')}`
          : null;

      forkJoin({
        person: this.accountCentreService.updateMyPerson({
          firstName: formData.firstName,
          lastName: formData.lastName,
          gender: formData.gender,
          dateOfBirth
        }),
        student: this.accountCentreService.updateMyStudentProfile({
          destination: formData.destination,
          degreePreference: formData.degreePreference,
          collageStartOn: formData.collageStartOn,
          homeCountry: typeof homeCountryPayload === 'string' ? homeCountryPayload : null
        })
      }).subscribe({
        next: () => {
          this.loading = false;
          this.loadUserData();
          this.submitted = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile details updated' });
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to update info.' });
        }
      });
      return;
    }

    this.accountCentreService.updateBasicInfo(request).subscribe({
      next: () => {
        this.loading = false;
        this.loadUserData();
        this.submitted = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Profile details updated' });
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to update info.' });
      }
    });
  }

  onProfileTextContentChange($event: EditorContent) {
    this.textContent = $event.textValue;
    this.htmlContent = $event.htmlValue;
    // this.totalWords = this.textContent.trim().split(/\s+/).filter(word => word).length;
    this.cdr.detectChanges();
  }

  resetEditorsContent() {
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      // Overwrite the inner HTML of the editor
      editor.innerHTML = this.initialContent;
    }
  }
}
